<template>
  <div class="layout-component">
    <el-container class="layout-container">
      <!-- 顶栏 -->
      <el-header class="header" height="80px" style="">
        <div class="header-left">
          <router-link to="/">
            <div class="logo-left"></div>
          </router-link>
          <!-- <span>{{ loginUser }}</span> -->
          <!-- <div>*** {{ login }}</div> -->
          <!-- <div @click="handleToggleAside" :class="{'el-icon-s-unfold':isCollapse,'el-icon-s-fold':!isCollapse}"></div> -->
        </div>
        <el-menu router class="user-right" mode="horizontal" @select="handleSelectMenu">
          <!-- 消息提示角标 -->
          <div @click="handleToOnline" class="icon-message">
            <el-badge class="item" v-if="messageNum == 0">
              <i class="el-icon-s-comment icon"></i>
            </el-badge>
            <el-badge class="item" :value="messageNum" v-else>
              <i class="el-icon-s-comment icon"></i>
            </el-badge>
          </div>
          <div @click="handleToOnline('message')" class="icon-message marginleft10">
            <el-badge class="item" v-if="getMsgData.xxCount == 0">
              <i class="el-icon-message-solid icon"></i>
            </el-badge>
            <el-badge class="item" :value="getMsgData.xxCount" v-else>
              <i class="el-icon-message-solid icon"></i>
            </el-badge>
          </div>
          <!-- /messagecenter/messagefeedback /overview/index-->
          <!-- <el-menu-item index="/messagecenter/messagefeedback" class="information">
            <el-badge v-if="getMsgData.xxCount == 0" class="item">
              <i class="el-icon-message-solid icon"></i>
            </el-badge>
            <el-badge  :value="getMsgData.xxCount" v-else class="item">
              <i class="el-icon-message-solid icon"></i>
            </el-badge>
          </el-menu-item> -->
          <div>
            <el-button class="change-type" @click="handleClickChangeType(1)" icon="el-icon-sort">{{
              languageDataObj.changetype[language] }}</el-button>
          </div>
          <div class="box-select">
            <el-select v-model="language" @change="handleChangeLanguageType" placeholder="请选择">
              <el-option v-for="item in optionsLanguage" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <!-- 头像 -->
          <div class="avatar">
            <div class="block">
              <el-avatar :size="42" :src="'/api' + login.supUserAvatar"></el-avatar>
            </div>
          </div>
          <!-- 姓名 || 登录账号-->
          <el-submenu index="3" class="work" style="padding-left: 8px; padding-right: 20px">
            <template slot="title">
              <div class="userinfo">
                <div v-if="
                  user.supInfo != undefined &&
                  user.supInfo.supName != undefined &&
                  user.supInfo.supName != null &&
                  user.supInfo.supName != ''
                " class="username loginName" :title="user.supInfo.supName != undefined &&
                      user.supInfo.supName != null
                      ? user.supInfo.supName
                      : null
                    ">
                  {{ user.supInfo.supName }}
                </div>
                <div v-if="
                  user.supInfo == undefined ||
                  user.supInfo.supName == undefined ||
                  user.supInfo.supName == null ||
                  user.supInfo.supName == ''
                " class="username supinfo" :title="login.supCurrentAccount">
                  {{ login.supCurrentAccount }}
                </div>

                <!-- <div class="grade">
									<i class="el-icon-warning gradeicon"></i>
									<span class="text">黄金级</span>
								</div> -->
              </div>
            </template>
            <!-- <el-menu-item index="">修改密码</el-menu-item> -->
            <!-- 个人中心 -->
            <el-menu-item index="/personalcenter/basicinformation">{{
              languageDataObj.myinformation[language]
            }}</el-menu-item>
            <el-menu-item @click="handleLoginOut">{{
              languageDataObj.logout[language]
            }}</el-menu-item>
          </el-submenu>
        </el-menu>
      </el-header>
      <!-- content -->
      <el-container>
        <!-- 侧栏 -->
        <el-aside class="aside">
          <el-menu :default-active="this.$store.state.sidePath" router class="el-menu-aside" @select="handleSelectMenu"
            @open="handleOpen" @close="handleClose">
            <el-menu-item index="/overview/index">
              <i class="el-icon-menu icon"></i>
              <span slot="title" class="title">{{
                languageDataObj.overview[language]
              }}</span>
            </el-menu-item>

            <el-submenu index="/personalcenter">
              <template slot="title">
                <i class="el-icon-s-custom icon"></i>
                <span slot="title" class="title">{{
                  languageDataObj.personalcenter[language]
                }}</span>
              </template>
              <el-menu-item-group>
                <el-menu-item style="padding-left: 55px" index="/personalcenter/basicinformation">{{
                  languageDataObj.myinformation[language] }}</el-menu-item>
                <el-menu-item style="padding-left: 55px" index="/personalcenter/myresume">{{
                  languageDataObj.myresume[language] }}</el-menu-item>
                <el-menu-item style="padding-left: 55px" index="/personalcenter/languagetest">{{
                  languageDataObj.languagetest[language] }}</el-menu-item>
                <el-menu-item style="padding-left: 55px" index="/personalcenter/personalverification">{{
                  languageDataObj.mysettlement[language] }}</el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <!-- 项目中心 -->
            <el-menu-item index="/projectcenter/projectlist">
              <i class="el-icon-s-order icon"></i>
              <span slot="title" class="title">{{
                languageDataObj.projectcenter[language]
              }}</span>
            </el-menu-item>
            <!-- 结算中心 -->
            <el-submenu index="/settlementcenter">
              <template slot="title">
                <i class="el-icon-s-finance icon"></i>
                <span slot="title" class="title">{{
                  languageDataObj.settlementcenter[language]
                }}</span>
              </template>

              <!-- 
                
               -->
              <el-menu-item-group>
                <el-menu-item style="padding-left: 55px" index="/settlementcenter/expensesettlement">{{
                  languageDataObj.feessettlement[language] }}</el-menu-item>
                <el-menu-item style="padding-left: 55px" index="/settlementcenter/expensedetail">{{
                  languageDataObj.settlementdetail[language]
                }}</el-menu-item>
                <el-menu-item style="padding-left: 55px" index="/settlementcenter/settlementApplicationRecord">{{
                  languageDataObj.settlementApplicationRecord[language]
                }}</el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <!-- 任务中心 -->
            <el-submenu index="/jobhall">
              <template slot="title">
                <i class="el-icon-s-claim icon"></i>
                <span slot="title" class="title">{{
                  languageDataObj.jobhall[language]
                }}</span>
              </template>
              <el-menu-item-group>
                <el-menu-item style="padding-left: 55px" index="/jobhall/joblist">{{ languageDataObj.joblist[language]
                  }}</el-menu-item>
                <el-menu-item style="padding-left: 55px" index="/jobhall/applicationrecord">{{
                  languageDataObj.applicationrecord[language]
                }}</el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <!-- 订单管理 -->
            <el-submenu index="/order">
              <template slot="title">
                <i class="el-icon-s-cooperation icon"></i>
                <span slot="title" class="title">{{
                  languageDataObj.order[language]
                }}</span>
              </template>
              <el-menu-item-group>
                <el-menu-item style="padding-left: 55px" index="/order/initiateAnOrderIndex">{{
                  languageDataObj.initiateAnOrderIndex[language]
                }}</el-menu-item>
                <el-menu-item style="padding-left: 55px" index="/order/AppealManagementYYIndex">{{
                  languageDataObj.AppealManagementYYIndex[language]
                }}</el-menu-item>
                <el-menu-item style="padding-left: 55px" index="/jobhall/evaluateRecord">{{
                  languageDataObj.EvaluateRecord[language] }}</el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <el-menu-item index="/onlinecommunication/index">
              <i class="el-icon-s-comment"></i>
              <span slot="title" class="title">{{
                languageDataObj.onlinecommunication[language]
              }}</span>
            </el-menu-item>
            <!-- 消息中心 -->
            <el-menu-item index="/messagecenter/messagefeedback">
              <i class="el-icon-message-solid icon"></i>
              <span slot="title" class="title">{{
                languageDataObj.messagefeedback[language]
              }}</span>
            </el-menu-item>
            <!-- 修改密码-安全中心 -->
            <el-menu-item index="/settings/settingsindex">
              <i class="el-icon-s-tools icon"></i>
              <span slot="title" class="title">{{
                languageDataObj.settings[language]
              }}</span>
            </el-menu-item>
          </el-menu>
        </el-aside>
        <!-- 内容 -->
        <el-container>
          <el-main class="main">
            <router-view></router-view>
          </el-main>
        </el-container>
      </el-container>
      <!-- 客服、小程序、公众号 -->
      <div class="requirementButton">
        <!-- 客服按钮 -->
        <el-tooltip class="item" effect="dark" content="联系客服" placement="left">
          <div :class="[
            'meun-switch animated Flex-row',
            uploadflag ? 'active rubberBand off' : 'leave jello'
          ]" @mouseleave="uploadleave" @mouseenter="uploadenter" @click.stop="relationService"
            style="border-radius: 50%">
            <!-- <img src="../../assets/images/projectInfoTypeYY.png" /> -->
            <div style="display: flex; flex-direction: column; align-items: center">
              <!-- <div class="icon-message" style="border-radius: 50%">
                <svg
                  t="1691114609229"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="2234"
                  width="200"
                  height="200"
                >
                  <path
                    d="M515.53 770.231c4.367 0 8.813-0.267 13.285-0.8 42.89-5.147 79.31-35.125 92.754-76.438 1.013-3.093-0.452-6.4-3.407-7.76-2.929-1.36-6.47-0.187-8.12 2.586-0.16 0.267-17.199 27.791-83.543 36.752-9.93 1.334-19.594 2.028-28.753 2.028-46.483-0.027-67.196-17.55-67.382-17.71-2.343-2.08-5.91-2.133-8.306-0.106-2.423 2.027-2.982 5.547-1.332 8.242 20.234 32.804 56.547 53.206 94.804 53.206z m356.723-411.153c-0.586 0-1.119 0.107-1.677 0.107-38.87-168.291-187.4-293.83-365.481-293.83-182.98 0-334.917 132.474-368.596 307.725-32.746 5.894-57.666 34.672-57.666 69.477v139.301c0 39.045 31.31 70.703 69.966 70.703 21.805 0 41.053-10.294 53.859-26.11 30.934 81.822 93.922 147.803 173.627 182.61 0.191-0.416 1.7-3.349 3.514-5.686 1.258-1.62 2.66-2.952 3.868-2.952 1.252 0 2.397 0.453 3.381 1.147-18.45-13.736-85.087-84.333-99.516-182.853-6.337-43.367 26.143-85.933 63.975-92.974 60.727-11.309 121.135-24.19 181.862-35.285 38.603-7.041 64.987-28.217 81.12-63.475 3.78-8.242 9.239-24.91 11.742-48.94 0.665-3.574 3.593-6.322 7.348-6.322 2.503 0 4.633 1.28 6.044 3.12l1.677-1.04c23.934 34.752 71.403 111.696 78.218 192.828 7.828 92.76 3.461 156.29-67.542 221.286a3 3 0 0 1-0.293 0.267 5.821 5.821 0 0 0-1.57 3.974c0 2 1.065 3.707 2.609 4.747 0.585 0.24 1.172 0.56 1.757 0.8 0.479 0.106 0.931 0.267 1.411 0.267s0.906-0.16 1.331-0.267c1.013-0.533 1.97-1.147 2.956-1.68 71.802-39.553 126.885-105.616 152.336-185.067 10.303 15.308 26.436 26.323 45.18 30.164-30.058 136.713-151.991 222.272-303.05 235.26-9.053-22.456-31.336-38.405-57.507-38.405-34.183 0-61.898 27.07-61.898 60.436s27.714 60.408 61.898 60.408c27.555 0 50.638-17.709 58.651-42.032 174.86-14.216 315.03-118.15 344.29-279.64 25.85-10.803 44.007-36.166 44.007-65.77V430.421c-0.002-39.392-32.164-71.344-71.831-71.344z m-64.508 40.486c-45.605-123.537-163.785-211.79-302.81-211.79-138.44 0-256.193 87.506-302.224 210.243-2.29-2.8-4.979-5.2-7.615-7.628 26.064-149.568 154.787-263.291 309.999-263.291 154.467 0 282.79 112.602 309.705 261.131-2.662 3.574-5.112 7.309-7.055 11.335z m-431.453 409.5l-0.008-0.003c-0.029 0.064-0.03 0.072 0.008 0.003z"
                    fill="#1296db"
                    p-id="2235"
                  ></path>
                </svg>
              </div> -->
              <div class="icon-message2">
                <img class="icon" src="../assets/iconFontSvg/kefu.svg" style="border-radius: 50%" />
              </div>
              <!-- <div style="padding-top: 5px; font-weight: 600">
              {{ languageDataObj.customerService[language] }}
            </div> -->
            </div>
          </div>
        </el-tooltip>
        <!-- 小程序按钮 -->
        <el-tooltip class="item" placement="left">
          <template #content>
            <div style="text-align: center; margin-bottom: 5px">微信小程序</div>
            <img src="@/assets/images/xiaochengxu.jpg" style="width: 100px; height: 100px" />
          </template>
          <div :class="[
            'meun-switch2 animated Flex-row',
            uploadflag ? 'active rubberBand off' : 'leave jello'
          ]" @mouseleave="uploadleave" @mouseenter="uploadenter" style="border-radius: 50%">
            <!-- <img src="../../assets/images/projectInfoTypeYY.png" /> -->
            <div style="display: flex; flex-direction: column; align-items: center">
              <div class="icon-message2">
                <img class="icon" src="../assets/iconFontSvg/xiaochengxu.svg" style="border-radius: 50%" />
              </div>
            </div>
          </div>
        </el-tooltip>
        <!-- 公众号按钮 -->
        <el-tooltip class="item" placement="left">
          <template #content>
            <div style="text-align: center; margin-bottom: 5px">微信公众号</div>
            <img src="@/assets/images/gongzhonghao.jpg" style="width: 100px; height: 100px" />
          </template>
          <div :class="[
            'meun-switch2 animated Flex-row',
            uploadflag ? 'active rubberBand off' : 'leave jello'
          ]" @mouseleave="uploadleave" @mouseenter="uploadenter" style="border-radius: 50%">
            <!-- <img src="../../assets/images/projectInfoTypeYY.png" /> -->
            <div style="display: flex; flex-direction: column; align-items: center">
              <div class="icon-message3">
                <img class="icon" src="../assets/iconFontSvg/weixingongzhonghao.svg" style="border-radius: 50%" />
              </div>
            </div>
          </div>
        </el-tooltip>
      </div>
    </el-container>
  </div>
</template>

<script>
// 导入辅助函数
import mixin from '@/mixin/mixin'
import { Admin, Basic, LiaoTian } from '@/api'
export default {
  name: 'Layout',
  mixins: [mixin],
  data() {
    var websocket = null //用于消息推送
    var supConversationId = null //会话id
    var websocketHH
    return {
      userInfo: {},
      //wsurl: 'ws://192.168.0.50:8081/socket/', //路由测试
      wsurl: 'wss://www.yedeer.com/besesunNew/socket/', //路由服务器
      login: {},
      // language
      languageDataObj: null,
      optionsLanguage: [],
      languageType: 1,
      // changeLanguageType:null
      // msgData:this.$store.getters.overviewData !=null && this.$store.getters.overviewData != '' && this.$store.getters.overviewData != undefined?this.$store.getters.overviewData:0,
      // 客服悬浮按钮
      uploadShow: false,
      uploadflag: true
    }
  },
  created() {
    //译员的顶部信息
    this.optionsLanguage = this.$store.state.optionsLanguageList
    this.languageType = this.$store.state.languageType
    this.backLanguageText('YYLayout')
    this.login = this.$cookies.get('loginUser')
    this.getUserInfo()
    this.openHHLink()
  },
  watch: {
    // 监听语言变化,并进行回调
    language: function (val, oldVal) {
      this.backLanguageText('YYLayout')
    }
  },
  computed: {
    // 计算监听数据
    language() {
      return this.$store.state.languageType
    },
    activeIndex() {
      return this.$store.getters.sidePath
    },
    // login() {
    //   return JSON.parse(sessionStorage.getItem('loginUser'))
    // },
    user() {
      let lo = this.$store.getters.user
      return lo
    },
    getMsgData() {
      return this.$store.getters.overviewData
    },
    messageNum() {
      return this.$store.state.messageNum
    }
  },
  methods: {
    // 打开新页面，联系客服
    relationService() {
      window.open(
        'https://www.yedeer.com/xqrelationservice?userId=' +
          this.login.supUserId +
          '&usertype=2'
      )
      // window.open(
      //   'http://localhost:8080/xqrelationservice?userId=' +
      //   this.login.supUserId +
      //   '&usertype=2'
      // )
    },
    // 客服悬浮按钮
    uploadenter() {
      this.uploadflag = true
    },
    uploadleave() {
      this.uploadflag = false
    },
    uploadanimated() {
      setTimeout(() => {
        this.uploadShow = true
        setTimeout(() => {
          this.uploadleave()
        }, 1000)
      }, 1000)
    },
    // 点击跳转到在线沟通页面
    handleToOnline(where) {
      if (where == 'message') {
        this.$router.push({ path: '/messagecenter/messagefeedback' })
      } else {
        this.$router.push({ path: '/onlinecommunication/index' })
      }
    },
    // 点击切换当前系统状态
    async handleClickChangeType(port) {
      // console.log('login*******',this.login)
      let back = await Admin.switchIdentity({
        loginName: this.login.supCurrentAccount,
        port: port
      })
      if (back.code == 0) {
        let user = JSON.stringify(back.data) //转换数据为json字符串
        window.localStorage.setItem('token', back.data.token) //存储token
        window.sessionStorage.setItem('loginUser', user) //存储登录用户信息
        this.$cookies.set('loginUser', user)
        // 缓存到仓库
        this.$store.commit('loginUser', user)

        this.$message.success(this.languageDataObj.login[this.language])

        if (back.data.port == 0) {
          this.$router.push('/overview/index')
        } else {
          this.$router.push('/xqoverview/index')
        }
      } else {
        this.$message.error(back.msg)
      }
    },
    // 开启自己的会话
    openHHLink() {
      // 关闭之前的连接
      if (this.websocketHH) {
        this.websocketHH.close();
      }
      this.websocketHH = new WebSocket(this.wsurl + '' + this.login.supUserId + '_' + this.login.supLoginName)
      let _this = this
      this.websocketHH.onmessage = function (event) {
        _this.getGYSUnreadmessage()
      }
      this.getGYSUnreadmessage()
    },
    async getGYSUnreadmessage() {
      let back = await LiaoTian.getGYSUnreadmessage({
        userId: this.login.supUserId,
        loginName: this.login.supLoginName,
        port: "0"
      })
      this.$store.commit('messageNumChange', back)
    },
    // 切换选择语种显示
    handleChangeLanguageType(val) {
      this.$store.commit('languageTypeChange', val)
    },
    // handleGetMessageStatus(){
    //   let _this = this
    //   setInterval(function(){
    //     _this.getUnreadMsg()
    //   },5000)
    // },
    // 调用接口获取概览页消息通知
    // getUnreadMsg(){
    //   User.getUnreadMsg({supUserId:this.login.supUserId}).then((res)=>{
    //     // // console.log(res)
    //     this.msgData = res
    //   }).catch((error)=>{
    //     // console.log(error)
    //   })
    // },
    //发送请求获取用户基本资料
    async getUserInfo() {
      // 发送请求获取用户信息
      let { code, msg, data } = await Basic.getOverviewData({
        supUserId: this.login.supUserId
      })
      if (code == 0) {
        // 存储概览页基础信息到公共仓库
        this.$store.commit('userMu', data)
        this.userInfo = data.supInfo
      } else {
        this.$message.error(msg)
      }
    },
    //退出登录
    handleLoginOut() {
      let _this = this
      this.$confirm(this.languageDataObj.logout[this.language] + '?', {
        confirmButtonText:
          this.languageDataObj.message.tongyong.yes[this.language],
        cancelButtonText:
          this.languageDataObj.message.tongyong.no[this.language],
        type: 'warning'
      })
        .then(async () => {
          let { supUserId } = { ...this.login }

          let { msg, code } = await Admin.loginOut({
            supUserId: supUserId
          })
          if (code === 0) {
            this.$message.success(
              this.languageDataObj.message.tongyong.msgsuccess[this.language]
            )
            window.localStorage.removeItem('token')
            setTimeout(function () {
              _this.$router.replace({ path: '/login' })
            }, 2000)
          } else {
            this.$message.error(
              this.languageDataObj.message.tongyong.msgerror[this.language]
            )
          }
        })
        .catch(() => {
          this.$message.warning(
            this.languageDataObj.message.tongyong.msgcancel[this.language]
          )
        })
    },
    //获取登录用户信息
    // getLoginUser() {
    //   // let loginUser = window.sessionStorage.getItem("loginUser");
    //   // this.$store.commit("loginUser", loginUser);

    // },

    handleToggleAside(e) {
      // //// console.log("点击");
      // this.$store.commit("Menu/toggleMenu");
    },
    handleSelectMenu(key, keyPath) {
      //   //// console.log(key, keyPath);
      this.$store.commit('Set_sidebar', key)
    },
    handleOpen(key, keyPath) {
      // //// console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      // //// console.log(key, keyPath);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// 侧边悬浮按钮样式
.off {
  -webkit-animation: 1s seconddiv;
  background: transparent;
}

@keyframes seconddiv {
  0% {
    transform: scale(1.4, 1.4);
  }

  10% {
    transform: scale(1, 1);
  }

  25% {
    transform: scale(1.2, 1.2);
  }

  50% {
    transform: scale(1, 1);
  }

  70% {
    transform: scale(1.2, 1.2);
  }

  100% {
    transform: scale(1, 1);
  }
}

.requirementButton {
  position: fixed;
  top: 500px;
  right: 10px;
  width: 50px;
  height: 170px;
  background-color: #ffffff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  border-radius: 5px;

  .meun-switch {
    // left: 0px;
    z-index: 2001;
    cursor: pointer;
    // width: 150px;
    // height: 150px;
    padding: 5px;
    transition: all 0.25s;

    // &.leave {
    //     left: -65px;
    // }

    // &.active {
    //     left: 0;
    // }

    &:hover {
      transform: scale(1.02);
    }

    img {
      width: auto;
      height: auto;
    }
  }

  .meun-switch2 {
    z-index: 2001;
    cursor: pointer;
    // width: 150px;
    // height: 150px;
    padding: 5px;
    transition: all 0.25s;
    // &.leave {
    //     left: -65px;
    // }

    // &.active {
    //     left: 0;
    // }

    &:hover {
      transform: scale(1.02);
    }

    img {
      width: auto;
      height: auto;
    }
  }

  .meun-switch3 {
    z-index: 2001;
    cursor: pointer;
    // width: 150px;
    // height: 150px;
    padding: 5px;
    transition: all 0.25s;
    // &.leave {
    //     left: -65px;
    // }

    // &.active {
    //     left: 0;
    // }

    &:hover {
      transform: scale(1.02);
    }

    img {
      width: auto;
      height: auto;
    }
  }
}

.layout-component {
  .item {
    // width: 3rem;
    height: 3rem;
    // background-color: #F6F6F6;
    border-radius: 15px;
    text-align: center;
    line-height: 3rem;

    .el-button--small {
      border: none;
      background-color: transparent;
      color: #a5a9b5;

      &:hover {
        color: #000;
      }
    }

    .iconbtn {
      font-size: 18px;
    }
  }

  .icon-message {
    position: relative;
    z-index: 99;
    margin: 0 0.5rem;
    width: 50px;
    height: 50px;
    display: block;
    // background: #f4f5f6;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s;

    .icon {
      // color: #909399;
      width: 100%;
      height: 100%;
      font-size: 18px;

      &:hover {
        color: #fff;
        cursor: pointer;
      }
    }

    // &:hover {
    //   background: #bfbfbf;

    //   .icon {
    //     color: #fff;
    //   }
    // }
  }

  .icon-message2 {
    position: relative;
    z-index: 99;
    margin: 0 0.5rem;
    width: 50px;
    height: 50px;
    display: block;
    // background: #f4f5f6;
    // border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s;

    .icon {
      width: 40px;
      height: 40px;
      border: none;

      &:hover {
        background-color: #bfbfbf;
        cursor: pointer;
      }
    }

    // &:hover {
    //   background-color: #bfbfbf;
    //   .icon {
    //     background-color: #bfbfbf;
    //   }
    // }
  }

  .icon-message3 {
    position: relative;
    z-index: 99;
    margin: 0 0.5rem;
    width: 50px;
    height: 50px;
    display: block;
    // background: #f4f5f6;
    // border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s;

    .icon {
      width: 35px;
      height: 35px;
      border: none;

      // background-color: #d2e7f9;
      &:hover {
        background-color: #bfbfbf;
        cursor: pointer;
      }
    }

    // &:hover {
    //   background-color: #bfbfbf;
    //   .icon {
    //     background-color: #bfbfbf;
    //   }
    // }
  }

  /**.header 头 */
  .header {
    height: 80px;
    background-color: #fff;
    display: flex;
    padding: 0 25px;
    justify-content: space-between;
    align-items: center;

    .header-left {
      display: flex;
      align-items: center;

      .toggle-btn {
        margin-left: 70px;
        font-size: 22px;
      }
    }

    .logo-left {
      height: 42px;
      width: 145px;
      // background-color: #13dd60;
      background: url('../assets/images/company-logo.png') center center/cover;
    }

    .user-right {
      // background-color: #c00;
      display: flex;
      align-items: center;

      .box-select {
        width: 105px;
      }

      .el-menu.el-menu--horizontal {
        border: none;
      }

      .information {
        width: 48px;
        height: 48px;
        font-size: 21px;
        color: #a4a9b5;
        // color: #000;
        padding: 3px;
        line-height: 48px;
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;

        .icon {
          width: 42px;
          height: 42px;
          display: block;
          background: #f4f5f6;
          border-radius: 14px;
          line-height: 42px;
          transition: all 0.1s linear;
        }
      }

      // .information:last-child{
      //   margin-left: 10px;
      // }

      .information:hover {
        .icon {
          background-color: rgba(0, 0, 0, 0.25);
          color: #fff;
        }
      }

      .el-menu--horizontal>.el-menu-item.is-active {
        border: none;
      }

      .el-badge__content {
        border: none;
      }

      .avatar {
        .el-avatar--circle {
          width: 42px;
          height: 42px;
          background-color: transparent;
          // border-radius: 50%;
          // overflow: hidden;
        }
      }

      .work {
        min-width: 150px;
        // width: 190px;
        display: flex;
        // background-color: #c00;

        .userinfo {
          height: 60px;
          display: flex;
          width: 130px;
          align-items: center;

          .username {
            width: 150px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            height: 22px;
            font-family: PingFangSC-Medium;
            font-weight: 600;
            font-size: 14px;
            color: rgba(0, 0, 0, 0.85);
            line-height: 22px;
            // padding-bottom: 4px;
            text-align: left;
          }

          .grade {
            height: 20px;
            font-family: ArialUnicodeMS;
            font-size: 16px;
            color: rgba(0, 0, 0, 0.35);
            line-height: 20px;
            display: flex;
            align-items: center;

            .gradeicon {
              width: 16px;
              height: 16px;
              // background-color: #c00;
            }

            .text {
              font-size: 12px;
              font-weight: 600;
              margin-left: 4px;
            }
          }
        }
      }

      //

      //
    }
  }

  .icon-message {
    margin-left: 8px;
    width: 42px;
    height: 42px;
    display: block;
    background: #f4f5f6;
    // background-color: #000;
    border-radius: 14px;
    line-height: 42px;
    transition: all 0.3s;

    .icon {
      color: #909399;
      font-size: 18px;
    }

    &:hover {
      background: #bfbfbf;

      .icon {
        color: #fff;
      }
    }
  }

  /**.aside 侧边栏 */
  .aside {
    height: auto;
    min-height: calc(100vh - 80px);
    box-sizing: border-box;
    width: 220px;
    max-width: 220px;
    background-color: #fff;
    text-align: left;

    .el-menu-aside {
      height: auto;
      min-height: calc(100vh - 80px);
      // padding-top: 24px;
      border: none;
      box-sizing: border-box;

      .icon {
        font-size: 24px;
        margin: 0;
      }

      .title {
        margin-left: 12px;
        // color: #000;
        font-weight: 600;
      }
    }
  }

  .main {
    padding: 24px;
  }
}

.marginleft10 {
  margin: 0 14px;
}

/deep/ .el-menu.el-menu--horizontal {
  border: none;
}

/deep/ .el-menu-item [class^='el-icon-'] {
  margin: 0;
}

/deep/ .el-menu--horizontal>.el-menu-item.is-active {
  border: none;
}

/deep/ .el-avatar>img {
  width: 46px;
  height: 46px;
  background-color: transparent;
  border-radius: 50%;
  overflow: hidden;
}

/deep/ .el-menu--horizontal>.el-menu-item {
  margin: 0 8px 0 24px;
  padding: 0;

  &.information {
    margin-left: 8px;
  }
}

/deep/ .el-menu.el-menu--horizontal {
  border-bottom: none;
}

/deep/ .el-menu--horizontal>.el-submenu .el-submenu__title {
  padding: 0 16px 0 0px;
  // width: 130px;
}

/deep/ .el-menu--horizontal>.el-submenu .el-submenu__icon-arrow {
  position: relative;
  left: 70%;
  top: -60px;
  font-size: 16px;
}

/deep/ .el-menu--horizontal>.el-submenu.is-active .el-submenu__title {
  border: none;
}

/deep/ .el-submenu__title i {
  font-size: 16px;
}

/deep/ .el-submenu .el-menu-item {
  font-size: 12px;
}

/deep/ .user-right {
  .box-select {
    .el-select {
      .el-input__inner {
        border-radius: 0.88rem;
        background-color: #f4f5f6;
      }
    }
  }
}

/deep/ .el-badge__content.is-fixed {
  right: 0;
}

/deep/ .change-type {
  padding: 5px 5px;
  height: 40px;
  box-sizing: border-box;
  border-radius: 0.88rem;
  margin-right: 5px;
  color: #606266;
  background-color: #f4f5f6;
  border-color: #dedede;

  &:hover {
    background-color: #f4f5f6;
    color: #606266;
    border-color: #c5c6c9;
  }

  .el-icon-sort {
    transform: rotate(90deg);
  }
}
</style>
